import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Phone, 
  Mail, 
  MapPin, 
  Facebook, 
  Twitter, 
  Instagram,
  Lock,
  Truck,
  Shield,
  HelpCircle,
  FileText,
  Home
} from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        {/* Logo and Description */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div className="space-y-4">
            <Link to="/" className="flex items-center">
              <Truck className="w-8 h-8 text-yellow-400 mr-2" />
              <span className="text-2xl font-bold">VHOLIC APPLIANCES</span>
            </Link>
            <p className="text-gray-400 text-sm">
              Your trusted source for quality washers and dryers. Professional installation and exceptional service guaranteed.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-yellow-400 flex items-center">
                  <Home className="w-4 h-4 mr-2" />
                  Home
                </Link>
              </li>
              <li>
                <Link to="/shop" className="text-gray-400 hover:text-yellow-400 flex items-center">
                  <Truck className="w-4 h-4 mr-2" />
                  Shop
                </Link>
              </li>
              <li>
                <Link to="/track-order" className="text-gray-400 hover:text-yellow-400 flex items-center">
                  <Shield className="w-4 h-4 mr-2" />
                  Track Order
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-yellow-400 flex items-center">
                  <HelpCircle className="w-4 h-4 mr-2" />
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Customer Service</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/warranty" className="text-gray-400 hover:text-yellow-400 flex items-center">
                  <Shield className="w-4 h-4 mr-2" />
                  Warranty Info
                </Link>
              </li>
              <li>
                <Link to="/shipping-information" className="text-gray-400 hover:text-yellow-400 flex items-center">
                  <Truck className="w-4 h-4 mr-2" />
                  Shipping Info
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-yellow-400 flex items-center">
                  <FileText className="w-4 h-4 mr-2" />
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-2">
                <Phone className="w-5 h-5 text-yellow-400" />
                <a href="tel:909-990-9090" className="text-gray-400 hover:text-yellow-400">
                  909‑990‑9090
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-5 h-5 text-yellow-400" />
                <a href="mailto:vholicllc@gmail.com" className="text-gray-400 hover:text-yellow-400">
                  vholicllc@gmail.com
                </a>
              </div>
              <div className="flex items-start space-x-2">
                <MapPin className="w-5 h-5 text-yellow-400 mt-1 flex-shrink-0" />
                <address className="not-italic text-gray-400">
                  1620 W 5th St<br />
                  Santa Ana, CA 92703
                </address>
              </div>
              <div className="flex flex-wrap items-center gap-4 pt-2">
                <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors" aria-label="Facebook">
                  <Facebook className="w-6 h-6" />
                </a>
                <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors" aria-label="Twitter">
                  <Twitter className="w-6 h-6" />
                </a>
                <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors" aria-label="Instagram">
                  <Instagram className="w-6 h-6" />
                </a>
                <a
                  href="https://www.yelp.com/biz/vholic-appliances-santa-ana-3"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center justify-center rounded-lg bg-red-600 px-4 py-2 text-sm font-bold text-white transition-colors hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-offset-2 focus:ring-offset-gray-900"
                  aria-label="View Vholic Appliances on Yelp"
                >
                  Yelp
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <p className="text-sm text-gray-400">
              &copy; {new Date().getFullYear()} Vholic Appliances. All rights reserved.
            </p>
            <Link 
              to="/admin/login"
              className="flex items-center px-4 py-2 mt-4 md:mt-0 bg-gray-800 hover:bg-gray-700 rounded-lg transition-colors"
            >
              <Lock className="w-4 h-4 mr-2" />
              Admin Login
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
